(() => {
  const loading = document.querySelector('.rebel-loading');
  const cursor = document.querySelector('.rebel-cursor');
  const glow = document.querySelector('.rebel-glow');

  window.addEventListener('load', () => {
    setTimeout(() => loading && loading.classList.add('is-hidden'), 1300);
  });

  document.addEventListener('mousemove', (event) => {
    if (cursor) {
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
    }
    if (glow) {
      glow.style.left = `${event.clientX}px`;
      glow.style.top = `${event.clientY}px`;
    }
  });

  document.querySelectorAll('a, button, input, .rebel-tilt-card').forEach((element) => {
    element.addEventListener('mouseenter', () => {
      if (cursor) {
        cursor.style.width = '42px';
        cursor.style.height = '42px';
      }
    });
    element.addEventListener('mouseleave', () => {
      if (cursor) {
        cursor.style.width = '22px';
        cursor.style.height = '22px';
      }
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.14 });

  document.querySelectorAll('.rebel-reveal').forEach((element) => observer.observe(element));

  const tilt = document.querySelector('.rebel-tilt-card');
  if (tilt) {
    tilt.addEventListener('mousemove', (event) => {
      const rect = tilt.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      tilt.style.transform = `perspective(900px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg)`;
    });
    tilt.addEventListener('mouseleave', () => {
      tilt.style.transform = '';
    });
  }
})();
